import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { ModerationStatusEnum } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';

type typeOfObject = 'collection' | 'service';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule, TranslateModule, IconComponent, SpinnersModule],
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBadgeComponent implements OnInit {
  @Input() type: typeOfObject = 'collection';
  @Input() status: ModerationStatusEnum;
  @Input() reason: string;
  constructor(public deviceService: DeviceDetectorService) {}

  ngOnInit() {}

  get isOnModeration(): boolean {
    return this.status === ModerationStatusEnum.default;
  }

  get isDeclined(): boolean {
    return this.status === ModerationStatusEnum.softDeclined;
  }
}
